import React from "react"
import { useIntl } from "react-intl"
import { SEO } from '../../../components/Seo/seo'
import { promocodes } from '../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from "../../../AuthenticatedUserContext"
import { FormLoader } from "../../../components/Loader/FormLoader"
import Layout from "../../../components/Dashboard/Layout/Layout"
import { LanguageConsumer } from "../../../LanguageContext"
import PromocodesContent from "../../../components/Dashboard/Subscription/PromocodesContent"
import { Redirect } from "react-router-dom"
import { NamedRoutes } from "../../../routes"
import { PromocodeConsumer, PromocodeProvider } from "../../../PromocodeContext"

const Promocodes = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Sidebar.Links.Promocodes' })}
        pathname={window.location.origin}
        titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
        image={promocodes.image}
        description={intl.formatMessage({ id: 'Sidebar.Links.Promocodes' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true} />}
            {!!Object.keys(userData).length &&
              <>
                {!!userData.is_admin ?
                  <Layout content={<LanguageConsumer>
                    {({ locale }) => (
                      <PromocodeProvider handleNotificationCall={handleNotificationCall}>
                        <PromocodeConsumer>
                          {({ performSearch, getPromocodes }) => (
                            <PromocodesContent
                              handleNotificationCall={handleNotificationCall}
                              locale={locale}
                              performSearch={performSearch}
                              getPromocodes={getPromocodes}
                            />
                          )}
                        </PromocodeConsumer>
                      </PromocodeProvider>
                    )}
                  </LanguageConsumer>} /> :
                  (!userDataLoading && <Redirect to={NamedRoutes.home} />)
                }
              </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default Promocodes